import { useEffect, useMemo, useState } from 'react';
import { globalStyles } from './global.style';
import { ColorModeContext } from './context';
import { COLOR_MODE, ColorMode } from './consts';
import { darkMode } from './darkMode/darkMode';
import { colorPalettes } from '.';
import { lightMode } from './lightMode/lightMode';
import { GlobalStyles, ThemeProvider } from '@mui/material';

const themes = {
  [COLOR_MODE.DARK_MODE]: darkMode,
  [COLOR_MODE.LIGHT_MODE]: lightMode,
  default: darkMode,
};

interface LinuiThemeProps {
  children: React.ReactNode;
  initialMode?: ColorMode;
  /**
   * Should use global styles
   * @default true
   */
  applyGlobalStyles?: boolean;
}

/**
 * TODO: Add light theme
 */
export function LinuiTheme(props: LinuiThemeProps) {
  const {
    children,
    initialMode = COLOR_MODE.DARK_MODE,
    applyGlobalStyles = true,
  } = props;
  const [mode, setMode] = useState<ColorMode>(initialMode);
  const providerValue = useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode: ColorMode) =>
          prevMode === COLOR_MODE.LIGHT_MODE
            ? COLOR_MODE.DARK_MODE
            : COLOR_MODE.LIGHT_MODE,
        );
      },
    }),
    [],
  );

  useEffect(() => setMode(initialMode), [initialMode]);

  return (
    <ColorModeContext.Provider value={providerValue}>
      {applyGlobalStyles && <GlobalStyles styles={globalStyles} />}
      <ThemeProvider theme={themes[mode] || themes.default}>
        {applyGlobalStyles && (
          <GlobalStyles
            styles={theme => ({
              body: {
                color: colorPalettes[theme.palette.mode].text.primary,
              },
            })}
          />
        )}
        {children}
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}
